import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function AnalyticsTracker() {
  const location = useLocation()

  useEffect(() => {
    if (typeof window.gtag !== 'function') return
    window.gtag('config', 'G-6ZX5PGWKKL', {
      page_path: location.pathname + location.search,
    })
  }, [location])

  return null
}
